import React from "react";
import { NavLink } from "react-router-dom";
import { FaHome, FaCrown, FaInfoCircle, FaUser } from "react-icons/fa";

const BottomNavBar = () => {
  return (
    <nav className="bottom_nav" aria-label="mobile bottom navigation">
      <NavLink to="/home" className="bn_item" title="Home">
        <FaHome />
        <span>Home</span>
      </NavLink>

      <NavLink to="/plan" className="bn_item" title="VIP">
        <FaCrown />
        <span>VIP</span>
      </NavLink>

      <NavLink to="/about" className="bn_item" title="About">
        <FaInfoCircle />
        <span>About</span>
      </NavLink>

      <NavLink to="/login" className="bn_item" title="Me">
        <FaUser />
        <span>Me</span>
      </NavLink>
    </nav>
  );
};

export default BottomNavBar;
